import { ScorePayload } from '@/types'
import HttpRepository from '../HttpRepository'
import Repository from '../Repository'

export interface ICollectRepository {
  getSlots: (
    id: string,
    params: { fromDate: string; toDate: string; type: string; language?: string },
  ) => Promise<any>
  patchSlots: (id: string, params: { slot: { start: string; end: string } }) => Promise<any>
  getCollect: (id: string, type: string, language?: string) => Promise<any>
  patchWaiting: (
    id: string,
    place: string,
  ) => Promise<{ data: { status: string; updated: boolean } }>
  createScore: (id: string, score: ScorePayload) => Promise<void>
}

export default class CollectRepository extends HttpRepository {
  async getSlots(
    id: string,
    params: {
      fromDate: string
      toDate: string
      type: string
      language?: string
    },
  ): Promise<any> {
    return await Repository.get(`${this.endpoint}/${id}/slots`, { params })
  }

  async patchSlots(id: string, params: { slot: { start: string; end: string } }): Promise<any> {
    return await Repository.patch(`${this.endpoint}/${id}`, params)
  }

  async getCollect(id: string, type: string, language?: string): Promise<any> {
    return await Repository.get(`${this.endpoint}/${id}`, { params: { type, language } })
  }

  async patchWaiting(
    id: string,
    place: string,
  ): Promise<{ data: { status: string; updated: boolean } }> {
    return await Repository.patch(`${this.endpoint}/${id}/awaiting`, { space: place })
  }

  async createScore(id: string, payload: ScorePayload): Promise<void> {
    await Repository.post(`${this.endpoint}/${id}/scores`, payload)
  }
}
